import { render } from "./ProductOffer.vue?vue&type=template&id=964a249a&scoped=true"
import script from "./ProductOffer.vue?vue&type=script&lang=js"
export * from "./ProductOffer.vue?vue&type=script&lang=js"

import "./ProductOffer.vue?vue&type=style&index=0&id=964a249a&scoped=true&lang=css"

import exportComponent from "E:\\ismailDosyalar\\gifSites2\\gifSites\\2022\\gesas\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-964a249a"]])

export default __exports__